import HighchartsModule from 'highcharts';

require('highcharts/modules/exporting')(HighchartsModule);
require('highcharts/modules/offline-exporting')(HighchartsModule);

export const Highcharts = HighchartsModule;
